import { MetadataColumn } from '@bechtel/sr-types';
import { ReactNode } from 'react';

export enum InputAppearance {
  SPECIAL = 'special',
  DEFAULT = 'default',
}
export enum FormLabelSize {
  XSMALL = 'XSMALL',
  SMALL = 'COMPACT',
  MEDIUM = 'DEFAULT',
  LARGE = 'LARGE',
}
export interface FormFieldProps {
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  changed?: boolean;
  inferedFieldName?: string;
  appearance?: InputAppearance;
  isMainCommodity?: boolean;
  memberName: string;
  children?: ReactNode;
  autofocus?: boolean;
  commodityName?: string;
  displayMemberName?: string;
  displayMemberId?: string;
  searchFieldName?: string;
  changeControlCheck?: boolean;
  alwaysEditable?: boolean;
  size?: FormLabelSize;
  convertToUpperCase?: boolean;
  showPicker?: boolean;
  pickListName?: string;
  pickField?: string;
  hasFieldPicklist?: boolean; // required when field array is used, it will not add the memberName for specific field.
  validate?: boolean; //skip the validation onChange action
  metadataMemberName?: string; // in case of field arrays, memberName is the fully quailified formik field name, metadaaMemberName is the column definition
  onParentBlur?: (e: React.FocusEvent<HTMLInputElement>) => void; // Allows the parent component's onBlur action to be used
  tagValidationType?: string;
  validateInferredField?: boolean;
  customMetadataColumn?: MetadataColumn | undefined;
}

export enum FormMode {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  CLONE = 'CLONE',
}
